import UIKit from '@bsb/library/dist/js/uikit.min'

export const showSuccess = message =>
  UIKit.notification({
    message: `${message}<span uk-icon='icon: success' class='icon-success'></span>`,
    status: 'success',
    pos: 'top-right',
    timeout: 3000
  })

export const showError = message =>
  UIKit.notification({
    message: `${message}<span uk-icon='icon: close' class='icon-fail'></span>`,
    status: 'danger',
    pos: 'top-right',
    timeout: 3000
  })
